<template>
  <div>
    <div class="font-bold mb-3">
      <p>{{ $i18nPresenter.t('Download slides') }}</p>
    </div>
    <ExportVersionModal
      :presentation="presentation"
      :exportType="exportType"
      v-if="isOpenExportVersionModal"
      @hide="isOpenExportVersionModal =false"
      @downloadLastVersion="exportPdf"
    />

    <div class="flex gap-3">
      <div class=" card-section" :class="{'disable-card': isLoadingExport}">
        <IconNeedUpgradePlanV2
          v-if="isPlanFree"
          :text="$i18nPresenter.t('This feature is not available in your current plan.')"
          :buttonText="$i18nPresenter.t('Upgrade')"
          class="cursor-pointer absolute inset-0"
          classIcon="absolute top-1 right-1"
          @openPlanUpgradeModal="openPlanUpgradeModal"
        />
        <div
          class="badge-option relative flex justify-center align-middle"
          @click="handleExport('pdf')"

          :class="{'pointer-events-none': isPlanFree }"
        >
          <img src="@/assets/images/icon/pdf-icon.svg" alt="" v-if="!loadingExportPdfV2">
          <aha-spinner v-else />
          PDF
        </div>
      </div>
      <div class=" card-section " :class="{'disable-card': isLoadingExport}">
        <IconNeedUpgradePlanV2
          v-if="isPlanFree"
          :text="$i18nPresenter.t('This feature is not available in your current plan.')"
          :buttonText="$i18nPresenter.t('Upgrade')"
          class="cursor-pointer absolute inset-0"
          classIcon="absolute top-1 right-1"
          @openPlanUpgradeModal="openPlanUpgradeModal"
        />
        <div
          class="badge-option"
          :class="{'pointer-events-none': isPlanFree }"
          @click="handleExport('image')"
        >
          <img
            v-if="!loadingExportImage"
            src="@/assets/images/icon/image-icon.svg"
            class="ml-1"
            alt=""
          >
          <aha-spinner v-else />
          {{ $i18nPresenter.t('Images') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Utils from '@/util'
import eventCategories from '@/constant/eventCategories'
import Config from '@/config'
// import socket from '@/socket'
// import sentry from '@/services/sentry'
import VueToastedUtils from '@/utils/vue-toasted.utils'
import ExportVersionModal from '@/components-v2/editor-share-v2/ExportVersionModal.vue'
import IconNeedUpgradePlanV2 from '@/components-v2/my-plan/IconNeedUpgradePlanV2.vue'

export default {
  name: 'DownloadSlideSection',
  components: { IconNeedUpgradePlanV2, ExportVersionModal },
  props: {
    presentation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loadingExportPdf: false,
      isOpenExportVersionModal: false,
      exportType: '',
    }
  },
  computed: {

    ...mapState({
      currentUser: (state) => state.currentUser,
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
      canViewerShare: (state) => state.canViewerShare,
      isGuestUser: (state) => state.currentUser.isGuest,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      loadingExportImage: (state) => state.loadingExportImage,
      loadingExportPdfV2: (state) => state.loadingExportPdfV2,
      canEditPresentation: (state) => state.canEditPresentation,
    }),
    isPlanFree() {
      return !this.$store.state.plan || this.$store.state.plan.group === 'free'
    },
    isLoadingExport() {
      return this.loadingExportImage || this.loadingExportPdfV2
    },
  },
  methods: {
    ...mapActions('presentationReport', [
      'selectPresentationAction',
      'openReportPanelAction',
      'clearPresentationReportAction',
      'generateReportAction',
      'subscribeReportAction',
    ]),
    ...mapActions(['updateCurrentUserAction', 'setLoadingExportPdfAction', 'setLoadingExportImageAction']),
    openPlanUpgradeModal() {
      Utils.mixpanelTracking(
        eventCategories.PRESENTATION_EDITOR,
        'Feature upgrade',
        'Report',
      )
      return this.$router.push('/apps/user-plan?redirect=/apps/user-plan')
    },
    async exportPdf(exportType) {
      VueToastedUtils.showToast(this.$i18nPresenter.t('Downloading slides...'), {}, {
        className: ['custom-toast__loading'],
        hasReturnValue: true,
        action: {
          class: 'custom-toast__loading-url',
        },
      })
      const isDisable = this.loadingExportImage ||
          this.loadingExportPdfV2
      if (isDisable) return
      if (!exportType && (this.loadingExportPdf || this.loadingExportPdfV2)) return
      if (exportType === 'image' && this.loadingExportImage) return
      if (exportType && exportType === 'image') {
        this.setLoadingExportImageAction(true)
        this.$store.state.exportingType = 'image'
        Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
          // eslint-disable-next-line sonarjs/no-duplicate-string
          eventAction: 'Result > Download report > Select Download Format',
          eventLabel: 'Image',
          eventCategory: eventCategories.PRESENTATION_REPORT,
        })
      } else {
        this.setLoadingExportPdfAction(true)
        this.$store.state.exportingType = 'pdf'
        Utils.trackGA4AndMixpanel(eventCategories.PRESENTATION_REPORT, {
          eventAction: 'Result > Download report > Select Download Format',
          eventLabel: 'PDF',
          eventCategory: eventCategories.PRESENTATION_REPORT,
        })
      }

      await this.$http.post(Config.workerApi.exportPdf, {
        exportType: exportType === 'image' ? 'image' : 'pdf',
        id: this.presentation.id,
      }).then((response) => {
        // const { data } = response
        // const isNoUserInSocketRoom = data && data.numberOfClientInRoom === 0
        // if (isNoUserInSocketRoom) {
        //   const userId = this.$store.state.currentUser.id
        //   const isSocketConnected = socket.connected
        //   const socketId = socket.getSocketId()
        //   sentry.captureMessage(`Export PDF: No client in room ${userId}. Is socket connected ${isSocketConnected}, socketId ${socketId}`)
        //   socket.emit('join-user', `user-${userId}`)
        // }
        const exportData = { ...this.presentation.exportData, status: 'processing', requestAt: Date.now() }

        this.$store.dispatch('onlyPatchPresentationAction', { exportData })

        Utils.mixpanelTracking(eventCategories.PRESENTATION_REPORT, 'Results menu > Request Export PDF > Success')
        return response
      },
      (err) => {
        const exportData = { ...this.presentation.exportData, status: 'failure', failureAt: Date.now() }

        this.$store.dispatch('onlyPatchPresentationAction', { exportData })

        this.$store.state.loadingExportPdf = false
        this.$store.state.exportingType = null
        Utils.mixpanelTracking(eventCategories.PRESENTATION_REPORT, 'Results menu > Request Export PDF > Failed', JSON.stringify(err))
      })
    },
    async handleExport(type) {
      if (this.isPlanFree) {
        return
      }

      if (this.presentation.exportData) {
        const mappingExportType = {
          pdf: 'pdfUrl',
          image: 'zipUrl',
        }
        const property = mappingExportType[type]
        const linkDownload = this.presentation.exportData[property]
        if (linkDownload) {
          this.isOpenExportVersionModal = true
          this.exportType = type
          return
        }
      }

      this.exportPdf(type)
    },

  },
}
</script>

<style scoped lang="scss">
.side-center-modal-share-slide {
  .side-center_title {
    font-size: 14px;
    line-height: 18px;
  //letter-spacing: 0rem;
    text-align: left;
    margin-bottom: 12px;
  }
}
p{
  color : #282E3E;
}
.card-section{
  position: relative;
  border-radius: 4px;
  cursor: pointer;
  background: theme('colors.gray.0');
  border: 1px solid theme('colors.gray.40');
  color: theme('colors.gray.100');

  &:not(.disable-card):hover {
    background: theme('colors.purple.10');
    border-color: theme('colors.purple.30');
    color: theme('colors.purple.50');
  }
}

.disable-card {
  background: theme('colors.gray.40');
  border-color: theme('colors.gray.40');
  color: theme('colors.gray.60');
  cursor: not-allowed;
  pointer-events: none;

  img {
    opacity: 0.5;
  }
}
.badge-option {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 4px;
  border-radius: 4px;
  width: 108px;
  height: 68px;
}
</style>
